import { ERROR, REMOVE_ERROR } from "./types";

export interface ErrorSetter {
  setError: (message: string) => void;
}

export const setError = (message: string) => (dispatch: any) => {
  dispatch({ type: ERROR, payload: { message } });
};

export const removeError = () => (dispatch: any) => {
  dispatch({ type: REMOVE_ERROR });
};
